<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-html="value" />
  </div>
</template>

<script>
export default {
  name: "view-c-protocolo-ano-referencia",
  props: {
    label: String,
    value: String
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/AnoReferencia.vue